// React
import { ReactElement } from 'react';
// Utils
import { computeColorsFromBackgroundColor } from '@utmb/utils/colors';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Image } from '@utmb/design-system/image/Image';
import { Link } from '@utmb/design-system/link/link';
import { Placeholder } from '@utmb/design-system/placeholder/Placeholder';
// Interfaces
import { Slice } from '@utmb/types/slice-handler';
import SliceBannerMiniView from '@utmb/types/view/SliceBannerMiniView';
// Styles
import styles from './banner-mini.module.scss';
import { useGlobal } from '@utmb/contexts/GlobalContext';
import { LinkPositionEnum } from '@utmb/types/enum/LinkPositionEnum';

export const BannerMini = (props: Slice<SliceBannerMiniView>): ReactElement => {
    const { id, title, mainColor, picture, pictureAlign, link, isDark, linkPosition, summary } = props;

    const {
        global: {
            event: { primaryColorIsDark, secondaryColorIsDark },
        },
    } = useGlobal();

    const { backgroundColor, buttonBgColor, buttonColor, textColor, titleColor } = computeColorsFromBackgroundColor(
        mainColor,
        isDark ?? false,
        primaryColorIsDark,
        secondaryColorIsDark,
        linkPosition
    );

    const contentContainerCSS = ['col-12', 'col-xl-4', styles.content_container, !link && styles.container_without_margin].filter(Boolean).join(' ');

    return (
        <div id={id} className={`container ${styles.root}`}>
            <div className="row">
                <div className={contentContainerCSS} style={{ backgroundColor }}>
                    {title && (
                        <Font.FuturaHeavy mobile="24" desktop="36" className={styles.title} color={titleColor}>
                            {title}
                        </Font.FuturaHeavy>
                    )}
                    {summary && (
                        <Font.FuturaMedium mobile="16" desktop="20" color={textColor} className={styles.summary}>
                            {summary}
                        </Font.FuturaMedium>
                    )}
                    {link && linkPosition === LinkPositionEnum.BELOW_TEXT && (
                        <div className={styles.link_container}>
                            <Link.Button
                                href={link.slug}
                                bgcolor={buttonBgColor}
                                color={buttonColor}
                                label={link.label}
                                followClassName={`${link.followClass}-ga`}
                            />
                        </div>
                    )}
                </div>
                <div className={`col-12 col-xl-8 ${styles.image_container}`}>
                    {picture ? (
                        <Image objectFit="cover" objectPosition={pictureAlign} layout="fill" image={picture} className={styles.filtered_img} />
                    ) : (
                        <Placeholder />
                    )}
                    {link && linkPosition === LinkPositionEnum.OVER_IMAGE && (
                        <div className={styles.link_container}>
                            <Link.Button href={link.slug} bgcolor={mainColor} label={link.label} followClassName={`${link.followClass}-ga`} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
